import { useAuthContext } from './AuthProvider';

export const Authenticated = ({ children, toLogin }) => {
  const { isUserAuthenticated } = useAuthContext();

  return isUserAuthenticated ? children : toLogin;
};
